/**
 * Platform-specific module for web
 * Provides Firebase analytics, push notifications, and platform utilities
 */

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";
export { FontAwesomeIcon };

/**
 * Firebase configuration for web platform.
 * The apiKey is injected at runtime via initFirebase() after fetching from the backend.
 */
const firebaseConfig = {
  authDomain: "ancient-house-718.firebaseapp.com",
  databaseURL: "https://ancient-house-718.firebaseio.com",
  projectId: "ancient-house-718",
  storageBucket: "ancient-house-718.firebasestorage.app",
  messagingSenderId: "580523859069",
  appId: "1:580523859069:web:0c5d3dc85baf3e2c70e514",
  measurementId: "G-FXZ4N4RZPC",
};

let analytics = null;
export let app = null;

/**
 * Initializes Firebase with the provided API key.
 * Must be called once the key has been fetched from the backend.
 *
 * @param {string} apiKey - The Firebase API key retrieved from the API.
 */
export const initFirebase = (apiKey) => {
  if (analytics) return; // Already initialized
  app = initializeApp({ ...firebaseConfig, apiKey });
  analytics = getAnalytics(app);
};

/**
 * Logs an analytics event to Firebase (production only).
 * No-ops if Firebase has not been initialized yet.
 * @param {string} name - Event name
 * @param {Object} params - Event parameters
 */
export const logAnalyticsEvent = (name, params) => {
  if (!analytics) return;
  if (process.env.REACT_APP_ENV === "prod") {
    logEvent(analytics, name, params);
  }
};

/**
 * Logs an error event to Firebase analytics.
 * No-ops if Firebase has not been initialized yet.
 * @param {string} name - Error event name
 * @param {Object} params - Error parameters
 */
export const logError = (name, params) => {
  if (!analytics) return;
  logEvent(analytics, name, params);
};

/**
 * Current platform identifier
 */
export const platform = "web";

/**
 * Icon size for tab navigation
 */
export const tabIconSize = "xl";

/**
 * Icon sizes for home screen elements
 */
export const homeIconSizes = {
  garbage: "2xl",
  button: "m",
  addressLookupIcons: "lg",
};

/**
 * Detects if the current device is mobile or mobile web
 * @returns {boolean} True if mobile device detected
 */
export const isMobileOrMobileWeb = () => {
  if (typeof window === "undefined") {
    return false;
  } else {
    const userAgent = navigator.userAgent || window.opera;
    return /android|iphone|ipad|ipod/i.test(userAgent);
  }
};
